import React from 'react';
import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import {goBack} from "../../fn/navigation";
import CourseForm from "../../components/Courses/CourseForm";
import CardContent from "@material-ui/core/CardContent/CardContent";
import Card from "@material-ui/core/Card/Card";

const CoursesEdit = ({classes, course, formUrl, redirectAfterSubmit}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('courses.edit_course')}
            items={[
                {
                    icon: 'arrow_back',
                    text: i18n.get('schedules.back'),
                    href: redirectAfterSubmit,
                    onClick: (event) => {
                        event.preventDefault();
                        goBack(redirectAfterSubmit);
                    },
                }
            ]}
        />

        <Card>
            <CardContent>
                <CourseForm
                    values={course}
                    formUrl={formUrl}
                    isEdit={true}
                    redirectAfterSubmit={redirectAfterSubmit}
                />
            </CardContent>
        </Card>
    </Layout>
);

export default CoursesEdit;



// WEBPACK FOOTER //
// ./resources/assets/js/pages/accounts/Edit.jsx